import { FC } from 'react';
import cn from 'classnames';

import styles from './AppointmentCalendar.module.scss';

import type { INavigationButton } from '../config/declarations';

const NavigationButton: FC<INavigationButton> = ({ dispatch, isLeft = false }) => {
  const specificClassName = styles[`arrow${isLeft
    ? 'Left'
    : 'Right'
  }`];
  const action = isLeft
    ? 'prev'
    : 'next';

  return (
    <button
      type="button"
      className={styles.navButton}
      onClick={() => dispatch({ action })}
    >
      <i className={cn(styles.arrow, specificClassName)} />
    </button>
  );
};

export default NavigationButton;
